export enum DimensionUnit {
    cm = 'CM',
    inch = 'INCH',
    meter = 'M',
    mm = 'MM',
    ft = 'FEET',
}
